import { Router, useRouter } from 'vue-router';
import { useErrorStore } from '../../stores/useErrorStore';
import type { ErrorState } from '../../stores/useErrorStore';

function useErrorNavigation(router?: Router) {
  const errorStore = useErrorStore();
  const resolvedRouter = router ?? useRouter();
  const navigateToError = async (partial: Partial<ErrorState> = {}) => {
    errorStore.setError(partial);
    await resolvedRouter.push('/error');
  };

  const navigateToErrorPage = async () => {
    await resolvedRouter.push('/error');
  };

  const clearError = () => {
    errorStore.clearError();
  };

  return {
    navigateToError,
    navigateToErrorPage,
    clearError,
    errorStore,
  };
}

export default useErrorNavigation;
